// extracted by mini-css-extract-plugin
module.exports = {"root":"PasswordResetForm_root__2ZZdW","password":"PasswordResetForm_password__2dHz0"};